module.exports = __webpack_public_path__ + "static/media/send-blue-icon.70c145e8.svg";